export default __webpack_public_path__ + "static/media/Aswin.c910c35b.jpg";